export const FLIGHT_STEP_MS = 1000 / 60;

/** Presentation only: never feed fractional coordinates back into the replay engine. */
export function interpolateFlightState(target, previous, current, alpha) {
  const blend = Math.max(0, Math.min(1, alpha));
  Object.assign(target, current);
  for (const key of ["y", "distance", "velocity", "tick"]) {
    target[key] = previous[key] + (current[key] - previous[key]) * blend;
  }
  return target;
}
